import Observer from "./Observer";
import { isObject } from "./util";

export function observe (value, asRootData) {
    if (!isObject(value)) {
        return
    }
    let ob;
    if (value.hasOwnProperty('__ob__') && value.__ob__ instanceof Observer) {
        ob = value.__ob__;
    } else {
        ob = new Observer(value);
    }
    return ob;
}